import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/home-outline.svg'
import _imports_1 from '@/assets/icons/multi-property-icon.png'
import _imports_2 from '@/assets/icons/calendar.svg'
import _imports_3 from '@/assets/icons/moon.svg'
import _imports_4 from '@/assets/icons/guest-icon.png'
import _imports_5 from '@/assets/icons/pet-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6e12fe4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"fixed","z-index":"99","width":"100%","background":"white","box-shadow":"0px 1px 5px 0px rgba(194, 194, 194, 1)"} }
const _hoisted_2 = {
  style: {"width":"100%","display":"flex","flex-wrap":"wrap","overflow-x":"auto !important","overflow-y":"hidden","padding-left":"10px","padding-right":"10px","height":"53px"},
  class: "ion-nowrap"
}
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"40px"}
}
const _hoisted_5 = { style: {"margin-top":"75px"} }
const _hoisted_6 = {
  key: 0,
  lines: "none",
  style: {"max-width":"500px","margin":"auto"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  "data-v-4262366e": "",
  title: "Paid In Full",
  class: "reservation-status-marker mr-2",
  style: {"background":"rgb(0, 153, 0)"},
  slot: "end"
}
const _hoisted_9 = {
  key: 1,
  "data-v-4262366e": "",
  title: "Paid",
  class: "reservation-status-marker mr-2",
  style: {"background":"rgb(0, 153, 0)"},
  slot: "end"
}
const _hoisted_10 = {
  key: 2,
  "data-v-4262366e": "",
  title: "Confirmed",
  class: "reservation-status-marker mr-2",
  style: {"background":"linear-gradient(\n                                                transparent 0%,\n                                                transparent 50%,\n                                                rgb(255, 170, 0) 50%,\n                                                rgb(255, 170, 0) 100%\n                                            )","border":"2px solid rgb(255, 170, 0)"},
  slot: "end"
}
const _hoisted_11 = {
  key: 3,
  "data-v-4262366e": "",
  title: "Unconfirmed",
  class: "reservation-status-marker mr-2",
  style: {"border":"2px solid rgb(204, 0, 0)"},
  slot: "end"
}
const _hoisted_12 = {
  key: 4,
  "data-v-4262366e": "",
  title: "Cancelled",
  class: "reservation-status-marker mr-2",
  style: {"background":"rgb(158, 158, 158)","border-radius":"0px"},
  slot: "end"
}
const _hoisted_13 = {
  key: 0,
  slot: "start",
  style: {"margin-inline-end":"0px"}
}
const _hoisted_14 = {
  key: 0,
  style: {"width":"100px","height":"40px"},
  src: _imports_0
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 2,
  style: {"width":"100px","border-radius":"10px"},
  src: _imports_1
}
const _hoisted_17 = {
  key: 1,
  slot: "start"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100px","height":"40px"},
  src: _imports_0
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(255, 170, 0)"} }, "Confirmed", -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(0, 153, 0)"} }, "Paid In Full", -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(0, 153, 0)"} }, "Paid", -1))
const _hoisted_29 = { key: 3 }
const _hoisted_30 = {
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(204, 0, 0)"} }, "Unconfirmed", -1))
const _hoisted_32 = { key: 4 }
const _hoisted_33 = {
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(113, 113, 113)"} }, "Cancelled", -1))
const _hoisted_35 = {
  style: {"padding-left":"2px"},
  class: "ldx-quick-amenities"
}
const _hoisted_36 = { class: "ldx-quick-amenity" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_38 = { class: "ldx-quick-amenity" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_40 = { class: "ldx-quick-amenity" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "ldx-quick-amenity"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-weight":"700","font-size":"medium","padding-left":"15px","color":"red"},
  "text-wrap": ""
}, " BLOCKED ", -1))
const _hoisted_47 = {
  key: 0,
  style: {"font-weight":"500","font-size":"small","padding-left":"15px"},
  "text-wrap": ""
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "ion-text-center",
  style: {"font-family":"'San Francisco', sans-serif","font-size":"large","font-weight":"500"}
}, " No Results ", -1))
const _hoisted_50 = {
  key: 2,
  style: {"position":"fixed","bottom":"0","z-index":"99","width":"100%","display":"flex","flex-wrap":"nowrap","overflow-x":"auto !important","overflow-y":"hidden","background":"white","box-shadow":"0px -1px 5px 0px rgba(194, 194, 194, 1)"},
  class: "ion-nowrap"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"100px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, {
    "page-title": "View Reservations",
    whiteBackground: "",
    removeMode: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ion_select, {
            class: "filter-button",
            modelValue: _ctx.timeframe,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeframe) = $event)),
            placeholder: "Select Timeframe"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "Yesterday" }, {
                default: _withCtx(() => [
                  _createTextVNode("Yesterday")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Today" }, {
                default: _withCtx(() => [
                  _createTextVNode("Today")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Last Week" }, {
                default: _withCtx(() => [
                  _createTextVNode("Last Week")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "This Week" }, {
                default: _withCtx(() => [
                  _createTextVNode("This Week")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Last Month" }, {
                default: _withCtx(() => [
                  _createTextVNode("Last Month")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "This Month" }, {
                default: _withCtx(() => [
                  _createTextVNode("This Month")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Last Year" }, {
                default: _withCtx(() => [
                  _createTextVNode("Last Year")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "This Year" }, {
                default: _withCtx(() => [
                  _createTextVNode("This Year")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Future" }, {
                default: _withCtx(() => [
                  _createTextVNode("Future")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_ion_select, {
            class: "filter-button",
            modelValue: _ctx.showType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showType) = $event)),
            placeholder: "Select Type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "Reservation" }, {
                default: _withCtx(() => [
                  _createTextVNode("Reservations")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Block" }, {
                default: _withCtx(() => [
                  _createTextVNode("Blocks")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "All" }, {
                default: _withCtx(() => [
                  _createTextVNode("All")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showType != 'Block')
            ? (_openBlock(), _createBlock(_component_ion_select, {
                key: 0,
                class: "filter-button",
                modelValue: _ctx.filterStatus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterStatus) = $event)),
                placeholder: "Select Status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select_option, { value: "All" }, {
                    default: _withCtx(() => [
                      _createTextVNode("All Statuses")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "PAID" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Paid/Paid In Full")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "PAIDDEPOSIT" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Confirmed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "NOTPAID" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Unconfirmed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "CANCELLED" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancelled")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.showType != 'Block')
            ? (_openBlock(), _createBlock(_component_ion_select, {
                key: 1,
                class: "filter-button",
                modelValue: _ctx.filterPet,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterPet) = $event)),
                placeholder: "Select Filter"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select_option, { value: "NoPet" }, {
                    default: _withCtx(() => [
                      _createTextVNode("No Pets")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "Pet" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Has Pets")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "All" }, {
                    default: _withCtx(() => [
                      _createTextVNode("No Pet Filter")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (!_ctx.isSearch)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 2,
                class: "filter-button",
                color: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSearch())),
                mode: "ios"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Open Search")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isSearch)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 3,
                class: "filter-button",
                color: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSearch())),
                mode: "ios"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Close")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_button, {
            class: "filter-button",
            color: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetFilters())),
            mode: "ios"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Reset Filters")
            ]),
            _: 1
          })
        ]),
        (_ctx.isSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ion_searchbar, {
                mode: "ios",
                debounce: 0,
                onIonInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchChange($event))),
                placeholder: "Search"
              }),
              (_ctx.isSearch && _ctx.getPlatform() != 'web')
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    class: "filter-button",
                    color: "primary",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideKeyboard()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Hide Keyboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ion_label, { style: {"color":"transparent"} }, {
              default: _withCtx(() => [
                _createTextVNode("Hi from Bobby!")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reservationList, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (_ctx.searchMatch(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.matchFilter(item) && item.state != 'BLOCKED')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_ion_card, {
                          mode: "ios",
                          onClick: ($event: any) => (_ctx.openControlPanelModal(item.id)),
                          style: {"margin":"10px","margin-bottom":"15px","margin-top":"15px","cursor":"pointer"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, { style: {"padding":"0px","margin":"5px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  style: {"height":"35px"},
                                  lines: "none",
                                  class: "ion-no-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      "text-wrap": "",
                                      style: {"font-weight":"700","padding-left":"20px","font-size":"medium"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.guest.full_name), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (item.state == 'PAID' && item.substate == 'PAID')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                                      : _createCommentVNode("", true),
                                    (item.state == 'PAID' && item.substate != 'PAID')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                                      : _createCommentVNode("", true),
                                    (item.state == 'PAIDDEPOSIT')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                      : _createCommentVNode("", true),
                                    (item.state == 'NOTPAID')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                                      : _createCommentVNode("", true),
                                    (item.state == 'CANCELLED')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_item, { lines: "none" }, {
                                  default: _withCtx(() => [
                                    (item.properties.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          (!item.properties[0].thumbnail_url && item.properties.length == 1)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                                            : _createCommentVNode("", true),
                                          (item.properties[0].thumbnail_url && item.properties.length == 1)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                style: {"width":"100px","border-radius":"10px"},
                                                src: item.properties[0].thumbnail_url
                                              }, null, 8, _hoisted_15))
                                            : _createCommentVNode("", true),
                                          (item.properties.length > 1)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.properties.length <= 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_list, {
                                      slot: "end",
                                      style: {"width":"100%","margin-bottom":"10px"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.properties, (list, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            style: {"font-weight":"700","font-size":"small","padding-left":"15px"},
                                            "text-wrap": "",
                                            key: index
                                          }, _toDisplayString(list.name), 1))
                                        }), 128)),
                                        (item.state == 'PAIDDEPOSIT')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                              _createElementVNode("p", _hoisted_21, [
                                                _createTextVNode(_toDisplayString(item.booking_method_name) + " · ", 1),
                                                _hoisted_22
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.state == 'PAID' && item.substate == 'PAID')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                              _createElementVNode("p", _hoisted_24, [
                                                _createTextVNode(_toDisplayString(item.booking_method_name) + " · ", 1),
                                                _hoisted_25
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.state == 'PAID' && item.substate != 'PAID')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                              _createElementVNode("p", _hoisted_27, [
                                                _createTextVNode(_toDisplayString(item.booking_method_name) + " · ", 1),
                                                _hoisted_28
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.state == 'NOTPAID')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _createElementVNode("p", _hoisted_30, [
                                                _createTextVNode(_toDisplayString(item.booking_method_name) + " · ", 1),
                                                _hoisted_31
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.state == 'CANCELLED')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                              _createElementVNode("p", _hoisted_33, [
                                                _createTextVNode(_toDisplayString(item.booking_method_name) + " · ", 1),
                                                _hoisted_34
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_35, [
                                          _createElementVNode("div", _hoisted_36, [
                                            _hoisted_37,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.from_date)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_38, [
                                            _hoisted_39,
                                            _createElementVNode("span", null, _toDisplayString(item.nights), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_40, [
                                            _hoisted_41,
                                            _createElementVNode("span", null, _toDisplayString(item.guests + item.children), 1)
                                          ]),
                                          (item.properties[0])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                (item.properties[0].number_of_pets > 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                      _hoisted_44,
                                                      _createElementVNode("span", null, _toDisplayString(item.properties[0].number_of_pets), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.matchFilter(item) && item.state == 'BLOCKED')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createVNode(_component_ion_card, {
                          mode: "ios",
                          style: {"margin":"10px","margin-bottom":"15px","margin-top":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, { style: {"padding":"0px","margin":"5px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  style: {"height":"35px"},
                                  lines: "none",
                                  class: "ion-no-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      "text-wrap": "",
                                      style: {"font-weight":"700","padding-left":"20px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(item.from_date)) + " - " + _toDisplayString(_ctx.formatDate(item.to_date)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_item, { lines: "none" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      style: {"width":"75px","margin-bottom":"10px"},
                                      color: "medium",
                                      src: _ctx.closeCircle
                                    }, null, 8, ["src"]),
                                    _createVNode(_component_ion_list, { style: {"width":"100%","margin-bottom":"10px"} }, {
                                      default: _withCtx(() => [
                                        _hoisted_46,
                                        (item.properties[0])
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(item.properties[0].name), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (_ctx.total <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            (_ctx.showType != 'All' && _ctx.total == 1)
              ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 0,
                  style: {"font-size":"larger","margin":"auto","margin-bottom":"20px","margin-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Total: " + _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.showType), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showType != 'All' && _ctx.total != 1)
              ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 1,
                  style: {"font-size":"larger","margin":"auto","margin-bottom":"20px","margin-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Total: " + _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.showType) + "s", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showType == 'All' && _ctx.total == 1)
              ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 2,
                  style: {"font-size":"larger","margin":"auto","margin-bottom":"20px","margin-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Total: " + _toDisplayString(_ctx.total) + " Reservation & Block", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showType == 'All' && _ctx.total != 1)
              ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 3,
                  style: {"font-size":"larger","margin":"auto","margin-bottom":"20px","margin-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Total: " + _toDisplayString(_ctx.total) + " Reservations & Blocks", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_51
    ]),
    _: 1
  }))
}